import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#403C6F",
      dark: "#332F5B",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#1C6DD0",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#1C1C1F",
      secondary: "#42425A",
      disabled: "#999893",
    },
    custom: {
      subtle: "#464663",
      border: "#5A5A72",
    },
    action: {
      disabled: "#999893",
      disabledBackground: "#EFEFEF",
    },
  },
  typography: {
    fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif; !important",

    h1: { fontSize: "2.25rem", fontWeight: 600, lineHeight: 1.2 },
    h2: { fontSize: "1.75rem", fontWeight: 600, lineHeight: 1.25 },
    h3: { fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: "1.25rem", fontWeight: 500, lineHeight: 1.3 },
    h5: { fontSize: "1.125rem", fontWeight: 500, lineHeight: 1.35 },
    h6: { fontSize: "1rem", fontWeight: 500, lineHeight: 1.4 },

    subtitle1: { fontSize: "0.9rem", fontWeight: 500, lineHeight: 1.35 },
    subtitle2: { fontSize: "0.8rem", fontWeight: 500, lineHeight: 1.3 },

    body1: { fontSize: "0.9rem", fontWeight: 400, lineHeight: 1.4 },
    body2: { fontSize: "0.8rem", fontWeight: 400, lineHeight: 1.35 },

    button: {
      fontSize: "0.8rem",
      fontWeight: 600,
      textTransform: "none",
      lineHeight: 1.2,
    },
    caption: { fontSize: "0.75rem", fontWeight: 400, lineHeight: 1.3 },
    overline: {
      fontSize: "0.7rem",
      fontWeight: 500,
      textTransform: "uppercase",
      letterSpacing: 0.8,
      lineHeight: 1.3,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.8rem",
          lineHeight: 1.2,
          "&:focus-visible": {
            outline: "2px solid #1C6DD0",
            outlineOffset: "2px",
          },
        },
        containedPrimary: {
          backgroundColor: "#403C6F",
          color: "#FFFFFF",
          "&:hover": { backgroundColor: "#332F5B" },

          "&.Mui-disabled": {
            backgroundColor: "#757575",
            color: "#FFFFFF",
          },
        },
        contained: {
          backgroundColor: "#403C6F",
          color: "#FFFFFF",
          "&:hover": { backgroundColor: "#332F5B" },
        },
        outlinedPrimary: {
          borderColor: "#403C6F",
          color: "#403C6F",
          "&:hover": { backgroundColor: "rgba(64,60,111,0.08)" },
          "&:focus-visible": {
            outline: "2px solid #1C6DD0",
            outlineOffset: "2px",
          },
        },
        textPrimary: {
          color: "#403C6F",
          "&:hover": { backgroundColor: "rgba(64,60,111,0.08)" },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&:focus-visible": {
            outline: "2px solid #1C6DD0",
            outlineOffset: "2px",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "inherit",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#1C1C1F",
          color: "#FFFFFF",
          fontSize: "12px",
          lineHeight: 1.4,
          padding: "6px 8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
          borderRadius: 4,
          letterSpacing: "0.3px",
        },
        arrow: {
          color: "#1C1C1F",
        },
      },
    },
  },
});

/**
 * The default theme object that can be used throughout the application.
 * @type {import('@mui/material/styles').Theme}
 */
export default theme;
